import tagTester from './_tagTester.js';

export default tagTester('Number');



//////////////////
// WEBPACK FOOTER
// ./~/_underscore@1.13.2@underscore/modules/isNumber.js
// module id = 533
// module chunks = 106